
export function setCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
}

export function getCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
        var temp = allCookieArray[i].trim();
        if (temp.indexOf(name) == 0)
            return temp.substring(name.length, temp.length);
    }
    return "";
}


export function cookieClose(){

    let cookie_notice_box = document.querySelector('.cookie-notice-box');
    let cookieNotice = getCookie('cookie_notice_accepted');

    if (cookieNotice) {
        cookie_notice_box.remove();
    }
    
    $('.cookie-notice-close').on("click", function (e) {
        e.preventDefault()
        cookie_notice_box.remove();
    })
}

export function cookieAccept(){

    let cookie_notice_box = document.querySelector('.cookie-notice-box');

    $('.cookie-notice-accept').on("click", function (e) {
        e.preventDefault()
        setCookie('cookie_notice_accepted', true, '30');
        cookie_notice_box.remove();
    })

}

export function cookieInit(){
    
    let cookieNotice = getCookie('cookie_notice_accepted');
    let cookie_notice_box = document.querySelector('.cookie-notice-box');

    if (!cookieNotice) {
        setTimeout(function(){
            cookie_notice_box.classList.remove('cookie_notice--hide')
        },10000)
    }
}




